export default __webpack_public_path__ + "static/domea-scheda-tecnica-797e50ebfa1da5a07ba273eb46d448e8.pdf";